<template>
  <div class="icon-position">
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="30" cy="30" r="30" fill="url(#paint0_linear_6072_9954)" />
      <defs>
        <linearGradient
          id="paint0_linear_6072_9954"
          x1="102.3"
          y1="30.3054"
          x2="-11.4751"
          y2="-10.1436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D51F27" />
          <stop offset="1" stop-color="#6D5DCF" />
        </linearGradient>
      </defs>
    </svg>
    <i class="number">{{ number }}</i>
  </div>
</template>
<script>
export default {
  name: "IconPosition",
  props: {
    number: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss">
.icon-position {
  width: 60px;
  display: block;
  height: 60px;
  margin: auto;
  position: relative;
  z-index: 1;
  .number {
    color: white;
    position: absolute;
    display: block;
    top: 47%;
    left: 50%;
    font-family: "Averta Cy", sans-serif;
    font-size: 2.2em;
    //font-weight: 400;
    //text-anchor: middle;
    transform: translate(-50%, -50%);
  }
}
</style>
